import { httpPost } from '../../../modules/api/axios_api';
import Constants from '../../../constants/constants';
import { ValidateTokenResponse } from './types';

/**
 * Validates password reset token provided in password reset URL
 *
 * @method validateResetToken
 * @memberof Password
 * @param  {string} token - Password reset token
 * @returns {Promise<ValidateTokenResponse>} - True/false success of request
 */
//DONE: token is necessary as an input for password reset
export const validateResetToken = async (token: string): Promise<ValidateTokenResponse | null> => {
  return httpPost(`${Constants.BACKEND_URL}/auth/validate-reset-token`, { Authorization: token })
    .then((response) => {
      if (response?.status === 200 && response?.data.success) {
        return response?.data;
      }
      return null;
    })
    .catch((error) => {
      throw Error(`Error validating reset token: ${error}`);
    });
};
